import Button from './_button.js'
import FlexPane from './_flex-pane.js'
import MiniEventItemContent from './_mini-event-item-content.js'

export default {
  name: 'MiniEventItem',
  values: {
    container: {
      configSet: Button,
      configValues: {
        style: {
          base: {
            flexDirection: 'column',
            padding: '8px',
            minHeight: '71px',
            maxHeight: '92px',
            _mobile_maxHeight: '78px',
          },
        },
      },
    },
    detailsContainer: {
      configSet: FlexPane,
      configValues: {
        itemSpacing: '8px',
        style: {
          alignItems: 'center',
          overflow: 'hidden',
        },
      },
    },
    content: {
      configSet: MiniEventItemContent,
      configValues: {},
    },
    contentActive: {
      configSet: MiniEventItemContent,
      configValues: {},
    },
    showIcon: true,
  },
  meta: {
    extendable: false,
  },
}
